export default function MigoMasterRoutes(staticTitle) {
    return [
        {
            path: '/pscmservice/migomaster',
            meta: {
                title: `${staticTitle} - Migo Online`
            },
            children: [
                {
                    path: '/pscmservice/migomaster',
                    name: 'migomaster',
                    meta: {
                        title: `${staticTitle} - Master Data Sloc`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/master-data/MasterData.vue');
                    }
                },
                {
                    path: '/pscmservice/migomaster/sloc',
                    name: 'sloc',
                    meta: {
                        title: `${staticTitle} - Master Data Sloc`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/master-data/MasterData.vue');
                    }
                },
                {
                    path: '/pscmservice/migomaster/info',
                    name: 'migomasterinfo',
                    meta: {
                        title: `${staticTitle} - Master Data Info`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/master-data/MasterData.vue');
                    }
                },
                {
                    path: '/pscmservice/migomaster/movementtype',
                    name: 'movementtype',
                    meta: {
                        title: `${staticTitle} - Master Data Movement Type`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/master-data/MasterData.vue');
                    }
                }
            ]
        }
    ];
}
